var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPendingAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.31886 0 5.67547 0.498516 4.27766 1.43251C2.87984 2.3665 1.79037 3.69402 1.14703 5.24719C0.503683 6.80036 0.335355 8.50943 0.663329 10.1583C0.991303 11.8071 1.80085 13.3217 2.9896 14.5104C4.17834 15.6992 5.6929 16.5087 7.34173 16.8367C8.99057 17.1646 10.6996 16.9963 12.2528 16.353C13.806 15.7096 15.1335 14.6202 16.0675 13.2223C17.0015 11.8245 17.5 10.1811 17.5 8.5C17.4977 6.24637 16.6014 4.0857 15.0079 2.49214C13.4143 0.898582 11.2536 0.00230787 9 0ZM12.0774 11.5774C11.9548 11.6999 11.7887 11.7687 11.6154 11.7687C11.4421 11.7687 11.2759 11.6999 11.1533 11.5774L8.53795 8.96205C8.4153 8.83955 8.34631 8.67335 8.34616 8.5V3.26923C8.34616 3.09582 8.41504 2.92951 8.53766 2.80689C8.66028 2.68427 8.82659 2.61538 9 2.61538C9.17341 2.61538 9.33972 2.68427 9.46234 2.80689C9.58496 2.92951 9.65385 3.09582 9.65385 3.26923V8.22974L12.0774 10.6533C12.1999 10.7759 12.2687 10.9421 12.2687 11.1154C12.2687 11.2887 12.1999 11.4548 12.0774 11.5774Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingAccount);
export default __webpack_public_path__ + "static/media/ic-pendingAccount.0a8a949bf9baee44f108f46789b87cc8.svg";
export { ForwardRef as ReactComponent };